export default __webpack_public_path__ + "static/media/firstlogo.086dc289.svg";